import SideNav, { NavIcon, NavItem, NavText } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import React, { useEffect, useState } from "react";
import { IoLogOut } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import {
  Appointment,
  Billing,
  DashboardIcon,
  Logo,
  Patient,
  Setting,
  Staff,
  Task,
} from "../../configs/svg.js";
import { ROLE, WEB_ROUTES } from "../../utils/constants.js";
import LogoutModal from "../modals/LogoutModal.jsx";
import ThemeModal from "./ThemeModal.js";
import { useSelector } from "react-redux";

const SideBar = () => {
  const [expandSideBar, setExpandSideBar] = useState(true);
  const [activeKey, setActiveKey] = useState("");
  const location = window.location;
  const [isOpen, setIsOpen] = useState(false);
  const user = useSelector(state => state.authInfo.user)


  const navigate = useNavigate();

  // Sidebar items data
  const sideBarData = [
    {
      eventKey: "dashboard",
      icon: <DashboardIcon />,
      text: "Dashboard",
      route: "/dashboard",
      role: [ROLE.ADMIN],
    },
    {
      eventKey: "staff",
      icon: <Staff />,
      text: "Staff",
      route: WEB_ROUTES.staff,
      role: [ROLE.ADMIN, ROLE.CLIENT],
    },
    {
      eventKey: "patients",
      icon: <Patient />,
      text: "Patients",
      route: WEB_ROUTES.patient,
      role: [ROLE.ADMIN, ROLE.CLIENT],
    },
    {
      eventKey: "task",
      icon: <Task />,
      text: "Task",
      route: WEB_ROUTES.task,
      role: [ROLE.CLIENT, ROLE.STAFF],
    },
    {
      eventKey: "appointment",
      icon: <Appointment />,
      text: "Appointment",
      route: WEB_ROUTES.appointment,
      role: [ROLE.CLIENT],
    },
    {
      eventKey: "billing",
      icon: <Billing />,
      text: "Billing",
      route: WEB_ROUTES.billing,
      role: [ROLE.CLIENT],
    },
    {
      eventKey: "staffattendance",
      icon: <Patient />,
      text: user?.user_type ==="STAFF" ? "Attendance" : "Staff Attendance",
      route: WEB_ROUTES.staffattendance,
      role: [ROLE.CLIENT, ROLE.STAFF],
    },
    {
      eventKey: "settings",
      icon: <Setting />,
      text: "Settings",
      route: WEB_ROUTES.settings,
      role: [ROLE.ADMIN, ROLE.CLIENT, ROLE.STAFF],
    },
  ];

  //   useEffect(() => {
  //     sideBarData.forEach((item) => {
  //       router.prefetch(item.route);
  //     });
  //   }, [router, sideBarData]);

  useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia("(max-width: 768px)").matches) {
        setExpandSideBar(false);
      } else {
        setExpandSideBar(true);
      }
    };

    // Run on mount
    handleResize();

    // Attach the event listener to handle window resizing
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const location = window.location.pathname;
    const currentItem = sideBarData.find(
      (item) => item.route + "/" === location
    );
    if (currentItem) {
      setActiveKey(currentItem.eventKey);
    }
  }, [sideBarData]);

  const filteredSideBarData = sideBarData.filter(item => item.role.includes(user?.user_type));

  return (
    <>
      <SideNav
        onSelect={(selected) => {
          setActiveKey(selected);
        }}
        className={`side-nav-bar ${expandSideBar ? "expanded" : "collapsed"}`}
        expanded={expandSideBar}
      >
        <div
          className={`d-flex top-header-image ${
            expandSideBar ? "padding-block" : "not-expanded"
          }`}
        >
          <div
            className={`logo mb-3 w-100 cursor ${
              expandSideBar ? "" : "d-none"
            }`}
          >
            <Link to="/dashboard">
              <Logo width={"81.65px"} height={"55.44px"} />
            </Link>
          </div>
          <SideNav.Toggle
            className={`${expandSideBar ? "" : "toggle-custom-side"}`}
            onClick={() => setExpandSideBar(!expandSideBar)}
          />
        </div>
        <div className={`horizontol-line-sidebar mb-4 `}></div>
        <SideNav.Nav defaultSelected={activeKey}>
          {filteredSideBarData.map((item) => (
            <NavItem
              eventKey={item.eventKey}
              key={item.eventKey}
              active={item.eventKey === activeKey}
              onClick={() => {
                setActiveKey(item.eventKey);
                navigate(item.route);
              }}
              className={`mb-3 ${item.route === location.pathname && "active"}`}
              // ${item.ROLE.includes(role) ? "" : "d-none"}
            >
              <NavIcon>
                {item.icon}
                {/* <img src={item.icon} alt="icon" className="nav-icon" /> */}
              </NavIcon>
              <NavText>{item.text}</NavText>
            </NavItem>
          ))}
          <NavItem
            onClick={() => {
              setIsOpen(true);
            }}
            className={`mb-3 log-out`}
          >
            <NavIcon>
              <IoLogOut color="red" />
            </NavIcon>
            <NavText className="text-danger">Logout</NavText>
          </NavItem>
        </SideNav.Nav>
      </SideNav>
      {isOpen && (
        <ThemeModal
          size={"sm"}
          modalContent={<LogoutModal setLogoutModal={setIsOpen} />}
          title={""}
          className={"edit-profile"}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  );
};

export default SideBar;
